module.exports = __webpack_public_path__ + "img/autonumus.83b3521d.jpg";